"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lucide_1 = require("lucide");
const locales_1 = require("@/locales");
const i18n_1 = require("@/common/i18n");
exports.default = {
    language: {
        name: (0, i18n_1.$)("settings.language"),
        description: (0, i18n_1.$)("settings.language.description"),
        icon: lucide_1.Languages,
        value: "zh-cn",
        type: "select",
        controlOptions: {
            selections: (0, locales_1.getLangList)().map((lang) => ({
                value: lang,
                text: (0, locales_1.getLocale)(lang)["lang"]
            }))
        }
    },
    layout: {
        name: (0, i18n_1.$)("settings.layout"),
        icon: lucide_1.PanelBottom,
        value: "bottom",
        type: "select",
        controlOptions: {
            selections: [
                { value: "top", text: (0, i18n_1.$)("settings.layout.top") },
                { value: "bottom", text: (0, i18n_1.$)("settings.layout.bottom") }
            ]
        }
    },
    fps: {
        name: (0, i18n_1.$)("settings.fps"),
        icon: lucide_1.MonitorCog,
        value: true,
        type: "toggle",
        controlOptions: {
            tooltip: "FPS"
        }
    },
    wallMode: {
        name: (0, i18n_1.$)("settings.border-wall"),
        icon: lucide_1.BrickWall,
        value: true,
        type: "toggle",
        controlOptions: {
            tooltip: (0, i18n_1.$)("settings.border-wall")
        }
    },
    gravity: {
        name: (0, i18n_1.$)("settings.gravity"),
        description: "g / m/s²",
        icon: lucide_1.MoveDown,
        value: 1,
        type: "input",
        controlOptions: {
            type: "number",
            minValue: 0,
        }
    },
    friction: {
        name: (0, i18n_1.$)("settings.friction"),
        description: "μ",
        icon: lucide_1.ArrowLeftRight,
        value: .3,
        type: "input",
        controlOptions: {
            type: "number",
            minValue: 0
        }
    },
    damping: {
        name: (0, i18n_1.$)("settings.damping"),
        description: "γ",
        icon: lucide_1.ArrowsUpFromLine,
        value: .9,
        type: "input",
        controlOptions: {
            type: "number",
            minValue: 0,
            maxValue: 1
        }
    },
    stableVelocity: {
        name: (0, i18n_1.$)("settings.stable-velocity"),
        description: "v / m/s",
        icon: lucide_1.ArrowUpFromLine,
        value: 5,
        type: "input",
        controlOptions: {
            type: "number",
            minValue: 1
        }
    },
};
